import { createUseStyles } from 'react-jss';

import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import { BreakPoints } from '@picsart/design-system/foundation/responsive';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { mediaQuery } from '@picsart/rc/helpers';

const useStyles = createUseStyles(
  {
    root: {
      marginBottom: Spacings.s64,
    },

    container: {
      maxWidth: 950,
      margin: [Spacings.s0, 'auto'],
    },
    // SKELETON
    headerFallback: {
      display: 'flex',
      flexDirection: 'column',
      gap: 16,
      alignItems: 'center',
      '& > div': {
        width: '100%',
      },
    },
    rootFallback: {},
    iconFallback: {
      '&&': {
        width: 80,
        height: 76,
      },
    },
    titleFallback: {
      height: 50,
      maxWidth: 300,
    },
    descriptionFallback: {
      maxWidth: 940,
      height: 48,
    },
    inputFallback: {
      maxWidth: 780,
      height: 40,
    },
    tabsFallback: {
      display: 'flex',
      gap: 8,
      justifyContent: 'center',
      marginTop: Spacings.s32,
      overflowY: 'auto',
      '-ms-overflow-style': 'none',
      '&::-webkit-scrollbar': {
        width: 0,
        height: 0,
      },
      [mediaQuery(BreakPoints.Small)]: {
        justifyContent: 'start',
      },
    },
    tabFallback: {
      width: 80,
      height: 40,
    },

    colorsFallback: {
      maxWidth: 1440,
      marginTop: Spacings.s40,
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'center',
      gap: 8,
      flex: '20%',
      '@media screen and (max-width: 900px)': {
        flex: '50%',
      },
      '@media screen and (max-width: 1200px)': {
        flex: '25%',
      },
    },
    colorFallback: {
      height: 114,
      maxWidth: 256,
      width: '100%',
      borderRadius: CornerRadius.r8,
    },
  },
  {
    name: 'color-colorMeanings',
  },
);

export default useStyles;
